import I18n from 'I18n';
export const getUserTimezoneString = () => {
  return I18n.moment.userTz().format('z');
};
export const getDaysFromToday = timestamp => {
  const now = I18n.moment.userTz();
  const startOfToday = now.clone().startOf('day');
  const momentInUserTimezone = I18n.moment.userTz(timestamp);
  const calendarDaysFromToday = momentInUserTimezone.clone().startOf('day').diff(startOfToday, 'days');
  return calendarDaysFromToday;
};
export const getDateString = timestamp => {
  const calendarDaysFromToday = getDaysFromToday(timestamp);
  const timeFormat = 'LT z';
  if (calendarDaysFromToday === 0) {
    return I18n.text('reports.table.todayWithTime', {
      time: I18n.moment.userTz(timestamp).format(timeFormat)
    });
  } else if (calendarDaysFromToday === -1) {
    return I18n.text('reports.table.yesterdayWithTime', {
      time: I18n.moment.userTz(timestamp).format(timeFormat)
    });
  } else {
    return I18n.moment.userTz(timestamp).format('lll z');
  }
};